module.exports = __webpack_public_path__ + "img/0011.50dff0cf.jpg";